var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-nav"},[(_vm.isShowBack)?_c('i',{staticClass:"btn-back",on:{"click":_vm.goBack}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.pageTitle)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }